export default __webpack_public_path__ + "img/ab18e1447e0cc9c4168eafabab356364.png";